import type { InventoryQueryLinkerSchema } from '@/_pages/settings/inventory-kits/shared/schemas/inventory';
import type { InventoryKitQuerySchema } from '@/_pages/settings/inventory-kits/shared/schemas/inventory-kit';

export type InventoryAndKitOptionType = InventoryQueryLinkerSchema | InventoryKitQuerySchema;

export type InventoryAndKitGroupedOption = {
  label: string;
  options: InventoryAndKitOptionType[];
};

export function isInventory(option: InventoryAndKitOptionType): option is InventoryQueryLinkerSchema {
  return 'current_stock' in option;
}

export function isKit(option: InventoryAndKitOptionType): option is InventoryKitQuerySchema {
  return !('current_stock' in option);
}
